import { useQuery } from "@apollo/client"
import { GET_PDR_REQUIREMENT_NOTICE_QUERY } from "../../queries/member"
import { COACH_TOOLS_API } from "../../../apolloClient"

// Until the backend serves pdrRequirementNotice the query fails validation and
// returns no data, so the widget keeps its pdrRequirements-only copy. "all"
// keeps that error (and any later resolver error) visible in Apollo.
export const usePdrRequirementNotice = () => {
  const { data, loading } = useQuery(GET_PDR_REQUIREMENT_NOTICE_QUERY, {
    context: { api: COACH_TOOLS_API },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  })

  return {
    loading,
    pdrRequirementNotice: data?.currentPerson?.pdrRequirementNotice ?? null,
  }
}

export default usePdrRequirementNotice
